import { load } from '@/router/routes/index';

export default [
    {
        path: 'profiles',
        name: 'profile.index',
        component: load('profile/ProfileIndex'),
        meta: { auth: true },
    },
    {
        path: 'customers/create',
        name: 'customer.create',
        component: load('profile/ProfileCreate'),
        props: { activeCollection: 'customer' },
        meta: { auth: true, editMode: true, forceCollapsedMenu: true },
    },
    {
        path: 'customers/:profileId',
        component: load('profile/ProfileDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('profile/ProfileShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'customer.show',
                        component: load('profile/ProfileShowOverview'),
                        meta: { auth: true },
                    },
                    {
                        path: 'events',
                        name: 'customer.show.events',
                        component: load('profile/ProfileShowEvents'),
                        meta: { auth: true },
                    },
                    {
                        path: 'sales_reports',
                        name: 'customer.show.sales_reports',
                        component: load('profile/ProfileShowSalesReports'),
                        meta: { auth: true },
                    },
                    {
                        path: 'attachments',
                        name: 'customer.show.attachments',
                        component: load('profile/ProfileShowAttachments'),
                        meta: { auth: true },
                    },
                ],
            },
            {
                path: 'edit',
                name: 'customer.edit',
                component: load('profile/ProfileEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
        ],
    },
    {
        path: 'leads/create',
        name: 'lead.create',
        component: load('profile/ProfileCreate'),
        props: { activeCollection: 'lead' },
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'leads/:profileId',
        component: load('profile/ProfileDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('profile/ProfileShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'lead.show',
                        component: load('profile/ProfileShowOverview'),
                        meta: { auth: true },
                    },
                    {
                        path: 'events',
                        name: 'lead.show.events',
                        component: load('profile/ProfileShowEvents'),
                        meta: { auth: true },
                    },
                    {
                        path: 'sales_reports',
                        name: 'lead.show.sales_reports',
                        component: load('profile/ProfileShowSalesReports'),
                        meta: { auth: true },
                    },
                    {
                        path: 'attachments',
                        name: 'lead.show.attachments',
                        component: load('profile/ProfileShowAttachments'),
                        meta: { auth: true },
                    },
                ],
            },
            {
                path: 'edit',
                name: 'lead.edit',
                component: load('profile/ProfileEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
        ],
    },
    {
        path: 'suppliers/create',
        name: 'supplier.create',
        component: load('profile/ProfileCreate'),
        props: { activeCollection: 'supplier' },
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'suppliers/:profileId',
        component: load('profile/ProfileDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('profile/ProfileShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'supplier.show',
                        component: load('profile/ProfileShowOverview'),
                        meta: { auth: true },
                    },
                    {
                        path: 'events',
                        name: 'supplier.show.events',
                        component: load('profile/ProfileShowEvents'),
                        meta: { auth: true },
                    },
                    {
                        path: 'sales_reports',
                        name: 'supplier.show.sales_reports',
                        component: load('profile/ProfileShowSalesReports'),
                        meta: { auth: true },
                    },
                    {
                        path: 'attachments',
                        name: 'supplier.show.attachments',
                        component: load('profile/ProfileShowAttachments'),
                        meta: { auth: true },
                    },
                ],
            },
            {
                path: 'edit',
                name: 'supplier.edit',
                component: load('profile/ProfileEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
        ],
    },
    {
        path: 'companies/create',
        name: 'company.create',
        component: load('profile/CompanyCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'profileCategories/create',
        name: 'profileCategory.create',
        component: load('profile/ProfileCategoryCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'profileBrands/create',
        name: 'profileBrands.create',
        component: load('profile/ProfileBrandCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },



];
